

<template>
  <div>
    <h2>Assigned manuscripts</h2>

    <v-data-table
      :headers="headers"
      :items="folders"
      :items-per-page="10"
      class="elevation-1 mt-5"
    >
      <template v-slot:[`item._id`]="{ item }">
        {{ formatFolderId(item._id) }}
      </template>
      <template v-slot:[`item.updatedAt`]="{ item }">
        <small>{{ formatDate(item.updatedAt) }}</small>
      </template>
      <template v-slot:[`item.__v`]="{ item }">
        <v-btn
          small
          outlined
          color="green"
          class="my-1 mr-1"
          :to="`/editorial/assigned/${item.manuscripts[0]._id}`"
          v-if="item.manuscripts && item.manuscripts.length > 0"
        >
          Versions Submitted
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import { formatDate, formatFolderId } from "../../tools/format";

export default {
  data: () => ({
    loading: false,
    deleting: false,
    folders: [],
    headers: [
      { text: "Updated", value: "updatedAt" },
      { text: "Manuscript ID", value: "_id" },
      {
        text: "Manuscript Title",
        align: "start",
        value: "manuscripts[0].title",
      },
      { text: "Actions", value: "__v", sortable: false },
    ],
  }),
  methods: {
    formatDate,
    formatFolderId,
    fetchSubmissions() {
      this.loading = true;
      this.$axios
        .get("/editorial/manuscripts/assigned")
        .then(({ data: response }) => {
          this.folders = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve manuscripts",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteManuscript(id) {
      this.deleting = true;

      this.$axios
        .delete(`/manuscript/${id}`)
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "info",
            message: "Manuscript deleted",
          });
          this.fetchSubmissions();
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not delete manuscript",
          });
        })
        .finally(() => {
          this.deleting = false;
        });
    },
  },
  mounted() {
    this.fetchSubmissions();
  },
};
</script>